import { render, staticRenderFns } from "./removeToken.vue?vue&type=template&id=6e37e4fa&scoped=true"
import script from "./removeToken.vue?vue&type=script&lang=js"
export * from "./removeToken.vue?vue&type=script&lang=js"
import style0 from "./removeToken.vue?vue&type=style&index=0&id=6e37e4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e37e4fa",
  null
  
)

export default component.exports